import React from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PhoneIcon from "@material-ui/icons/Phone";
import CakeIcon from "@material-ui/icons/Cake";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import DevicesIcon from "@material-ui/icons/Devices";
import PublicIcon from "@material-ui/icons/Public";
import StreetviewIcon from "@material-ui/icons/Streetview";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import TagFacesIcon from "@material-ui/icons/TagFaces";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Country from "../../../Prospective/countryList";

let FromDetails = {
  primaryDetails: {
    studentId: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "Student ID",
        autoComplete: "Student ID",
        name: "ses_student",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
      usb_univofmanitobastudentid: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "University of Manitoba Student ID",
        autoComplete: "University of Manitoba Student ID",
        name: "usb_univofmanitobastudentid",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    emailaddress1: {
      elementType: "input",
      elementConfig: {
        type: "email",
        label: "Email Address",
        autoComplete: "email",
        name: "emailaddress1",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <MailOutlineIcon style={{ color: "#959595" }} />,
      value: "",
    },
    firstname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        autoFocus: true,
        label: "First Name",
        autoComplete: "first-name",
        name: "firstname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
     ses_preferredname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Preferred Name",
        autoComplete: "preferred-name",
        name: "ses_preferredname",
        required: false,
        fullWidth: true,
        disabled: true,
        belowLabelText:"Pour ajouter ou modifier ton prénom choisi, envoie un courriel au Registrariat."
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
      display:"block"
    },
    middlename: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Middle Name",
        autoComplete: "middle-name",
        name: "middlename",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    lastname: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Last Name",
        autoComplete: "last-name",
        name: "lastname",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    birthdate: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Birthday",
        autoComplete: "birthdate",
        name: "birthdate",
        required: true,
        fullWidth: true,
        disabled: true,
      },
      icon: <CakeIcon style={{ color: "#959595" }} />,
      value: "",
    },
    gendercode: {
      elementType: "select",
      elementConfig: {
        options: [
          { value: 2, displayValue: "Female" },
          { value: 1, displayValue: "Male" },
          { value: 943240003, displayValue: "Non-binary" },
          { value: 943240010, displayValue: "Transgender" },
          { value: 943240005, displayValue: "Two-spirit" },
          { value: 943240011, displayValue: "Other" },
          { value: 943240009, displayValue: "I prefer not to answer" },
        ],
        name: "gendercode",
        label: "Gender",
      },
      value: "",
      disabled: true,
    },
    governmentid: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Social Insurance Number (SIN)",
        autoComplete: "governmentid",
        name: "governmentid",
        fullWidth: true,
        disabled: false,
      },
      icon: <AccountCircleIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  contact: {
    telephone1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Home Phone",
        autoComplete: "mobile-phone",
        name: "telephone1",
        required: true,
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
    mobilephone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Mobile Phone",
        autoComplete: "mobile-phone",
        name: "mobilephone",
        fullWidth: true,
      },
      icon: <PhoneAndroidIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  HomeAddress: {
    _ses_countryofresidence_value: {
      elementType: "select",
      elementConfig: {
        label: "Country *",
        name: "_ses_countryofresidence_value",
        // required: true,
        options: [],
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "Country can't be blank",
      icon: <PublicIcon style={{ color: "#959595" }} />,
      value: "",
      disabled: false,
    },
    address1_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address1_line1",
        required: true,
        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address1_city",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_stateorprovince: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "State or Province",
        autoComplete: "State or Province",
        name: "address1_stateorprovince",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address1_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address1_postalcode",
        required: true,
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  mailingAddress: {
    address2_country: {
      elementType: "select",
      elementConfig: {
        label: "Country *",
        name: "address2_country",
        required: true,
        options: [],
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "Country can't be blank",
      icon: <PublicIcon style={{ color: "#959595" }} />,
      value: "",
      disabled: true,
    },
    address2_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address2_line1",
        required: true,
        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address2_city",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_stateorprovince: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "State or Province",
        autoComplete: "State or Province",
        name: "address2_stateorprovince",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address2_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address2_postalcode",
        required: true,
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  billingAddress: {
    address3_country: {
      elementType: "select",
      elementConfig: {
        label: "Country",
        name: "address3_country",
        required: true,
        options: [],
      },
      maxLength: 80,
      isValid: false,
      errorMessage: "Country can't be blank",
      icon: <PublicIcon style={{ color: "#959595" }} />,
      value: "",
      disabled: true,
    },
    address3_line1: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Street",
        autoComplete: "Street",
        name: "address3_line1",
        required: true,
        fullWidth: true,
      },
      icon: <StreetviewIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address3_city: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "City",
        autoComplete: "City",
        name: "address3_city",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address3_stateorprovince: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "State or Province",
        autoComplete: "State or Province",
        name: "address3_stateorprovince",
        required: true,
        fullWidth: true,
      },
      icon: <LocationCityIcon style={{ color: "#959595" }} />,
      value: "",
    },
    address3_postalcode: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Zip Code/Postal Code",
        autoComplete: "Zip Code/Postal Code",
        name: "address3_postalcode",
        required: true,
        fullWidth: true,
      },
      icon: <AddLocationIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
  emergenencyContact: {
    name: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Name",
        autoComplete: "name",
        name: "ses_emergencycontactname",
        required: true,
        fullWidth: true,
      },
      icon: <AccountBoxIcon style={{ color: "#959595" }} />,
      value: "",
    },
    relationship: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Relationship",
        autoComplete: "Relationship",
        name: "ses_emergencycontactrelationship",
        required: true,
        fullWidth: true,
      },
      icon: <TagFacesIcon style={{ color: "#959595" }} />,
      value: "",
    },
    phone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        label: "Emergency Contact Number",
        autoComplete: "mobile-phone",
        name: "ses_emergencycontactphone",
        required: true,
        fullWidth: true,
      },
      icon: <PhoneIcon style={{ color: "#959595" }} />,
      value: "",
    },
  },
};

export default FromDetails;
